import { createRouter } from '@tanstack/react-router';
import { queryClient } from './api/client';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // data comes from TanStack Query; the router shouldn't cache loader results itself
  defaultPreloadStaleTime: 0,
  scrollRestoration: false,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
